export default __webpack_public_path__ + "static/media/BNB.96e204af.png";